module.exports = __webpack_public_path__ + "img/wework-avatar1.d0ac73ff.png";